// extracted by mini-css-extract-plugin
export default {"info":"info_info__MJpCJ","info--error":"info_info--error__lSFtx","info--success":"info_info--success__9rnN5","info--basic":"info_info--basic__96xeN"};